export const AI_CHAT_LAUNCHER_PATHS = [
  '/',
  '/contact',
  '/products',
  '/clients',
  '/partners',
  '/blog',
  '/newsletter',
  '/faq',
  '/terms',
  '/privacy',
  '/security',
  '/legal/msa',
  // Other Landing pages
  '/about',
  '/analysis-landing',
  '/financial-landing',
  '/integrations-landing',
  '/planning-landing',
] as const;

export function isAiChatLauncherPath(
  pathname: string | null | undefined,
): boolean {
  if (!pathname) return false;

  return AI_CHAT_LAUNCHER_PATHS.some(route =>
    route === '/'
      ? pathname === '/'
      : pathname === route || pathname.startsWith(`${route}/`),
  );
}
